var React = require('react');

function TriangleBottomMktng (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M63.4524 66.0653L56.7968 17.7386L121.213 58.4365L63.4524 66.0653Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M24.9891 93.2507L56.8591 17.6927L63.4838 65.9619L24.9891 93.2507Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M24.9961 93.252L63.4636 65.9824L121.217 58.4381L24.9961 93.252Z","fill":"#5915C7","key":2})]);
}

TriangleBottomMktng.defaultProps = {"width":"122","height":"116","viewBox":"0 0 122 116","fill":"none"};

module.exports = TriangleBottomMktng;

TriangleBottomMktng.default = TriangleBottomMktng;
